<script>
	import { onMount, onDestroy } from 'svelte';
	import lottie from 'lottie-web';
	import { getApiUrl, injectGlobalStyles } from './shared.js';

	export let size = '64px';

	const loaderPath = `${getApiUrl()}/Static/region/widgets/assets/loader.json`;

	let host;
	let container;
	let animation;

	onMount(() => {
		const root = host?.getRootNode();
		if (root instanceof ShadowRoot) {
			injectGlobalStyles(root);
		}

		animation = lottie.loadAnimation({
			container,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: loaderPath
		});
	});

	onDestroy(() => {
		animation?.destroy();
	});
</script>

<div class="loader" bind:this={host} style="--loader-size: {size}">
	<div class="loader-animation" bind:this={container}></div>
</div>

<style>
	:host { display: inline-block; }
	.loader { display: inline-flex; align-items: center; justify-content: center; }
	.loader-animation { width: var(--loader-size); height: var(--loader-size); }
</style>
